import { Module } from "vuex";
import { RootState } from "@/store/RootState";
import { mutations } from "@/components/channelChange/store/mutations";
import { getters } from "@/components/channelChange/store/getters";
import { actions } from "@/components/channelChange/store/actions";
import { ChannelChangeState } from "@/components/channelChange/types";

export const state: ChannelChangeState = {
  //channelNumber is an item used exclusively for ChannelChange component
  channelNumber: [],
  //id of active channel
  channelId: 0,
  showChannelChange: false,
  source: "",
  offset: 0
};

export const channelChange: Module<ChannelChangeState, RootState> = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
